import React, { useState } from "react";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import { useDeviceType } from "hooks";
import { theme } from "constants/theme";
import buttonIcon from "assets/images/Listening Button.png";
import { Navbar } from "components/navbar/index";
import { NavId } from "types/navigation";
import back from "assets/images/back-icon.png";
import greenBack from "assets/images/green-back-icon.png";
import { Modal } from "components/modal";
import { CloseBlock } from "components/closemomileDetail";
import { Blog } from "types/blog";
import { CustomHeadline, CustomText } from "components/ui";
import CardEffect from "components/sections/section-13/card-effect";
import { BlogViewer } from "../../BlogViewer";

interface PreviewBlogProps {
  singleBlog: Blog;
  setPreviewBlog: (value: boolean) => void;
  setSingleBlog: (value: Blog) => void;
}

export const PreviewArticle: React.FC<PreviewBlogProps> = ({
  singleBlog,
  setPreviewBlog,
  setSingleBlog,
}) => {
  const [translate, setTranslate] = useState(0);
  const [activeSection, setActiveSection] = useState<number>(0);
  const [isHovered, setIsHovered] = useState(false);
  const { device } = useDeviceType();
  const isDesktop = device === "desktop";
  const navigate = useNavigate();

  const navigateToTop = () => navigate("/");

  return (
    <div className={styles.section13}>
      <Navbar
        activeSection={activeSection}
        navigateToTop={navigateToTop}
        theme="black"
        logoVariant="noLogoText"
        blur
      />
      <Modal setTranslate={setTranslate} setActiveSection={setActiveSection} />
      <div className={styles.container}>
        <img
          src={isHovered ? greenBack : back}
          alt="img"
          className={styles.button}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => {
            setSingleBlog(singleBlog);
            setPreviewBlog(false);
          }}
        />
        <div className={styles.content}>
          {singleBlog && (
            <div className={styles.block1}>
              {!isDesktop && (
                <CloseBlock
                  id={NavId.Section11}
                  index={4}
                  handleClose={() => {
                    setSingleBlog(singleBlog);
                    setPreviewBlog(false);
                  }}
                />
              )}
              <div className={styles.centuries}>
                <CustomHeadline
                  size={isDesktop ? 32 : 24}
                  text={singleBlog.title}
                  color={theme.colors.neutral[20]}
                  styles={{
                    marginBottom: "10px",
                  }}
                />
                <div className={styles.p}>
                  <img src={buttonIcon} alt="buttonIcon" />
                  <CustomText
                    size={isDesktop ? 16 : 14}
                    text="Tap to hear this page come to life."
                    color={theme.colors.neutral[30]}
                    styles={{
                      fontStyle: "italic",
                      lineHeight: isDesktop ? "28px" : "18px",
                      fontWeight: "300",
                    }}
                  />
                </div>{" "}
                <BlogViewer blocks={singleBlog.customEditor.blocks} />
              </div>
            </div>
          )}
          <div className={styles.line}></div>
          {isDesktop && (
            <div className={styles.block2}>
              <div className={styles.links}></div>
            </div>
          )}
        </div>
      </div>
      {singleBlog && (
        <div className={styles.imageBox}>
          <CardEffect>
            <img
              className={styles.image}
              src={
                device !== "desktop" && device !== "tablet"
                  ? singleBlog.mobileInnerImageUrl
                  : singleBlog.desktopInnerImageUrl
              }
              alt={""}
            />
          </CardEffect>
        </div>
      )}
    </div>
  );
};
